module.exports = __webpack_public_path__ + "static/media/disease.eb363f16.svg";